/*
  A simpler take on the closed caption button that videojs provides
  Instead of a menu that has options to turn captions on + off + settings, we just render a normal boolean-y button.
  Like the picture-in-picture toggle button.
  Will use this simpler button if you've got only 1 subtitle track (which should be majority (all) of our cases) (if there are no subtitles, no button is displayed)
  Just call `player.simpleroSubtitleButton()`
*/

import videojs from 'video.js'
import { applyKeyboardShortcut } from '../keyboard_shortcut'
import './simpler_subtitle_button.scss'

const Button = videojs.getComponent('Button')
class SimplerSubtitleButton extends Button {
  constructor(player, options) {
    super(player, options)
    document.addEventListener('keydown', (e) => {
      if ((e.key === 'c' || e.key === 'C') && applyKeyboardShortcut(e.target)) {
        this.handleClick(e)
      }
    })
  }

  handleClick(e) {
    this.options_.tracks[0].mode = this.isShowing ? 'hidden' : 'showing'
    this.toggleClass('vjs-simpler-subtitle-button-active', this.isShowing)
    window.UserPreference.set('subtitles', this.isShowing)
  }

  buildCSSClass() {
    return `vjs-simpler-subtitle-button ${
      this.isShowing ? 'vjs-simpler-subtitle-button-active' : ''
    } ${super.buildCSSClass()}`
  }

  get isShowing() {
    return this.options_.tracks[0].mode == 'showing'
  }
}
SimplerSubtitleButton.prototype.controlText_ = 'Subtitles'
videojs.registerComponent('SimplerSubtitleButton', SimplerSubtitleButton)

videojs.registerPlugin('simplerSubtitleButton', function () {
  const player = this
  player.ready(() => {
    const tracks = player
      ?.textTracks()
      ?.tracks_.filter((track) =>
        ['captions', 'subtitles'].includes(track.kind)
      )

    if (tracks.length == 1) {
      const controlBar = player.controlBar
      const subCapsButton = controlBar.getChild('SubsCapsButton')
      const index = controlBar.children().indexOf(subCapsButton)
      player.controlBar.removeChild(subCapsButton)
      player.controlBar.addChild('SimplerSubtitleButton', { tracks }, index)
    }
  })
})
